import React from 'react';
import View from "react-native-web/dist/exports/View";
import StyleSheet from "react-native-web/dist/exports/StyleSheet";
import Platform from "react-native-web/dist/exports/Platform";
import PropTypes from 'prop-types';
import StackView from '../StackView';
import Typography from '../Typography';
import RenderActivityIndicator from './RenderActivityIndicator';
import { activityIndicatorCommonProps } from './sharedProptypes';
import { SPACE_WITH_LABEL, SPACE_WITHOUT_LABEL } from './shared';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const InlineIndicator = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    variantProps,
    label,
    labelPosition,
    labelMapping,
    showLabel
  } = _ref;
  return /*#__PURE__*/_jsx(View, {
    style: staticStyles.container,
    children: /*#__PURE__*/_jsxs(StackView, {
      space: showLabel ? SPACE_WITH_LABEL : SPACE_WITHOUT_LABEL,
      direction: labelMapping[labelPosition],
      tokens: {
        alignItems: 'center'
      },
      children: [/*#__PURE__*/_jsx(RenderActivityIndicator, {
        ...variantProps,
        ref: ref,
        label: label
      }), showLabel && /*#__PURE__*/_jsx(Typography, {
        children: label
      })]
    })
  });
});
InlineIndicator.displayName = 'InlineIndicator';
const staticStyles = StyleSheet.create({
  container: {
    flexDirection: 'column',
    alignItems: 'center',
    display: Platform.OS === 'web' ? 'inline-flex' : 'flex',
    alignSelf: 'flex-start'
  }
});
InlineIndicator.propTypes = {
  /**
   * Shared props
   * */
  ...activityIndicatorCommonProps,
  /**
   * Whether the indicator sits inline with text/other elements
   * */
  inline: PropTypes.bool
};
export default InlineIndicator;